import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	internal_game_ids: data.gameIds,
});
